<template>
<div class="">
  <div class="relative text-white bg-black">

    <div class="absolute inset-0">
            <nuxt-img class="w-full h-full" src="/assets/images/bg-section-books.jpg" width="1920"
            height="893" format="webp" loading="lazy" sizes="xs:1920px sm:1920px md:1920px lg:1920px xl:1920px " />
        </div>

    <div class="relative z-10 px-4 py-10 mx-auto md:py-16 lg:py-12">

      

      <div class="flex flex-col items-center max-w-5xl mx-auto gap-x-8 lg:gap-x-16 md:flex-row">
        <!-- Left Content Section -->
        <div class="mb-8 md:w-8/12 md:mb-0">
          <h1 class="mb-6 text-xl font-bold text-center md:text-xl lg:text-26 font-ww-bold md:text-left">FREE Better Brain Builder Kit</h1>
          
          <div class="mb-6  md:text-lg text-base font-ww-regular !leading-5">
            Unlock your cognitive potential with this transfomative toolkit!
            Includes:
          </div>
          
          <ul class="mb-4">
            <li class="flex items-start">
              <span class="mr-2">•</span>
              <span>30-Day Challenge (daily brain-boosting habits)</span>
            </li>
            <li class="flex items-start">
              <span class="mr-2">•</span>
              <span>30-Day Diet Plan (neuronourishing meals)</span>
            </li>
            <li class="flex items-start">
              <span class="mr-2">•</span>
              <span>10 Brain Toxins Report (hidden threats to avoid)</span>
            </li>
            <li class="flex items-start">
              <span class="mr-2">•</span>
              <span>2026 Brain Hacks (cutting-edge biohacks)</span>
            </li>
          </ul>
          
          <div class=" md:text-lg text-base !leading-5">Science-backed, action-driven—start optimizing your mind today!</div>
          <div class="mb-8 text-base font-bold md:text-lg font-ww-bold">Claim yours FREE.</div>
          
          <!-- Bonus Section with Dark Gray Background -->
          <div class="flex flex-col items-center px-3 py-4 bg-[#333333] rounded-lg sm:flex-row">
            <div class="mb-4 sm:w-1/3 md:mb-0">
                <nuxt-img class="object-cover w-full h-full xl:max-h-[892px] lg:rounded-tr-lg lg:rounded-br-lg lg:rounded-bl-none lg:rounded-tl-none rounded-bl-lg rounded-br-lg " src="/assets/images/bonus-product.png" width="164"
                height="188" format="webp" loading="lazy" sizes="xs:164px sm:164px md:164px lg:164px xl:164px " />
            </div>
            <div class="leading-6 md:text-17 text-15 sm:w-2/3 md:pl-4">
                <strong>3 pack  Bonus:</strong> Frother <br><strong>3 pack Bonus:</strong> Scoop<br><br>
<strong>6 pack Bonus:</strong> 6 months’ worth of triple strength free omega 3’s.  <br><br>

Join the Movement. Upgrade Your Brain.
            </div>
          </div>
        </div>
        
        <!-- Right Images Section -->
        <div class="relative md:mt-16 md:w-1/2">
          <div class="relative z-10 grid grid-cols-2 gap-x-1 gap-y-2">
            <div class="">
                <nuxt-img class="mx-auto" src="/assets/images/neuroflow-book-1.png" width="187"
                height="240" format="webp" loading="lazy" sizes="xs:187px sm:187px md:187px lg:187px xl:187px " />
            </div>
            <div class="">
                <nuxt-img class="mx-auto" src="/assets/images/neuroflow-book-2.png" width="187"
                height="240" format="webp" loading="lazy" sizes="xs:187px sm:187px md:187px lg:187px xl:187px " />
            </div>
            <div class="">
                <nuxt-img class="mx-auto" src="/assets/images/neuroflow-book-1.png" width="187"
                height="240" format="webp" loading="lazy" sizes="xs:187px sm:187px md:187px lg:187px xl:187px " />
            </div>
            <div class="">
                <nuxt-img class="mx-auto" src="/assets/images/neuroflow-book-2.png" width="187"
                height="240" format="webp" loading="lazy" sizes="xs:187px sm:187px md:187px lg:187px xl:187px " />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
</template>

<script setup>

</script>